import { HStack } from '@bpba/ui-components';
import { FC } from 'react';
import { useTextLoadingAnimation } from './useTextLoadingAnimation';

type Props = {
  messages: string[] | undefined;
};

export const TextLoadingAnimation: FC<Props> = ({ messages }) => {
  const index = useTextLoadingAnimation(messages?.length);

  if (!messages || messages.length === 0) return <></>;

  const message = messages[index];

  return (
    <HStack justifyContent="center" alignItems="center" color={'primary.0'}>
      {`${message}...`}
    </HStack>
  );
};
